import { SectionError } from '@components/ui/error';
import { SectionLoader } from '@components/ui/loader';

import { HeaderBreadcrumb } from '@/components/ui';
import { Route } from '@/constants';
import { AddOrderPayment } from '@/modules/sales/order-details/add-payment.component.tsx';

import { OrderDetailsProvider, useOrderDetailsContext } from './context';
import { CustomerInfo } from './customer-info.component';
import { InvoiceDetails } from './invoice-details.component';
import { InvoiceHeader } from './invoice-header.component';
// import { OrderPayment } from './order-payment.component';
import { TransactionHistory } from './transaction-history.component';

const OrderDetailsComponent = () => {
    const { error, isLoading, isError } = useOrderDetailsContext();

    if (isLoading) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={Route.SALES} />;
    }

    return (
        <main className="min-h-[calc(100vh_-_var(--header-height)_-_16px)] bg-background p-4">
            <HeaderBreadcrumb
                showHomeLink={true}
                items={[
                    { label: 'Sales', href: Route.SALES },
                    { label: `Sales Details` },
                ]}
            />
            <div className="mx-auto mt-2">
                {/* Header with Actions */}
                <InvoiceHeader />

                {/* Main Content Grid */}
                <div className="mt-3 grid gap-4 lg:grid-cols-3">
                    {/* Invoice Details - Left Side */}
                    <div className="lg:col-span-2">
                        <InvoiceDetails />
                    </div>

                    {/* Customer Info - Right Side */}
                    <div className="space-y-4">
                        <CustomerInfo />
                        <AddOrderPayment />
                        {/* <OrderPayment /> */}
                    </div>
                </div>

                {/* Transaction History */}
                <div className="mt-4">
                    <TransactionHistory />
                </div>
            </div>
        </main>
    );
};

// Wrapper Component to provide context
export const OrderDetails = () => {
    return (
        <OrderDetailsProvider>
            <OrderDetailsComponent />
        </OrderDetailsProvider>
    );
};

OrderDetails.displayName = 'OrderDetails';
